import React from 'react';
import { Link } from 'react-router-dom';

const testimonials = [
  {
    name: 'Sarah L.',
    quote: 'Adding a VendPro machine to our office was the best decision! Employees love the convenience and it pays for itself.',
  },
  {
    name: 'Mike D.',
    quote: 'I started with one vending machine and now have five. The support and reliability are unmatched.',
  },
  {
    name: 'Jessica R.',
    quote: 'The machine is sleek, easy to use, and my customers are happy. Highly recommend VendPro!',
  },
];

function Home() {
  return (
    <>
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-blue-100 to-blue-300 py-16 md:py-24 mb-16">
        <div className="container mx-auto px-4 flex flex-col md:flex-row items-center">
          <div className="w-full md:w-1/2 mb-8 md:mb-0 text-center md:text-left">
            <h1 className="text-3xl md:text-5xl font-extrabold mb-6 text-blue-900">Maximize Profits with Modern Vending Machines</h1>
            <p className="text-lg md:text-2xl mb-8 text-gray-700">Unlock passive income and delight your customers or employees with our state-of-the-art vending solutions for soft drinks, candy bars, and chips.</p>
            <Link to="/pricing" className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-4 px-8 rounded-lg text-lg w-full md:w-auto inline-block">See Pricing</Link>
          </div>
          <div className="w-full md:w-1/2 flex justify-center">
            <img src="https://images.unsplash.com/photo-1519864600265-abb23847ef2c?auto=format&fit=crop&w=500&q=80" alt="Vending Machine" className="rounded-lg shadow-lg w-full max-w-xs md:max-w-md h-auto mx-auto" />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="container mx-auto px-4 mb-24">
        <div className="text-center mb-16">
          <h2 className="text-2xl md:text-4xl font-bold mb-6 text-blue-800">Why Choose VendPro?</h2>
          <p className="text-base md:text-lg text-gray-600">Our machines are designed for maximum uptime, easy maintenance, and unbeatable ROI.</p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          <div className="bg-white rounded-lg shadow-md p-8">
            <h3 className="text-lg md:text-2xl font-semibold mb-4 text-blue-700 text-center">Smart Inventory</h3>
            <p className="text-base md:text-lg text-gray-600">Real-time stock alerts and remote monitoring keep your machine full and profitable.</p>
          </div>
          <div className="bg-white rounded-lg shadow-md p-8">
            <h3 className="text-lg md:text-2xl font-semibold mb-4 text-blue-700 text-center">Cashless Payments</h3>
            <p className="text-base md:text-lg text-gray-600">Accept cards, mobile payments, and more—no more missed sales due to cash-only machines.</p>
          </div>
          <div className="bg-white rounded-lg shadow-md p-8">
            <h3 className="text-lg md:text-2xl font-semibold mb-4 text-blue-700 text-center">Plug & Play</h3>
            <p className="text-base md:text-lg text-gray-600">Easy setup in minutes. No technical expertise required—just plug in and start earning.</p>
          </div>
        </div>
      </div>

      {/* Testimonials Section */}
      <div className="bg-gray-50 py-16 md:py-24 mb-24">
        <div className="container mx-auto px-4">
          <div className="text-center mb-16">
            <h2 className="text-xl md:text-3xl font-bold text-blue-800 mb-4">What Our Customers Say</h2>
            <p className="text-base md:text-lg text-gray-600">Hear from real customers who have transformed their business with VendPro</p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 justify-center">
            {testimonials.map((t, idx) => (
              <div 
                className={`bg-white rounded-lg shadow-lg p-8 transform transition-transform duration-300 hover:scale-105 ${
                  idx === 1 ? 'md:translate-y-8' : ''
                }`} 
                key={idx}
              >
                <div className="mb-4">
                  <svg className="w-8 h-8 text-blue-200 mb-4" fill="currentColor" viewBox="0 0 24 24">
                    <path d="M14.017 21v-7.391c0-5.704 3.731-9.57 8.983-10.609l.995 2.151c-2.432.917-3.995 3.638-3.995 5.849h4v10h-9.983zm-14.017 0v-7.391c0-5.704 3.748-9.57 9-10.609l.996 2.151c-2.433.917-3.996 3.638-3.996 5.849h3.983v10h-9.983z"/>
                  </svg>
                </div>
                <p className="italic mb-6 text-gray-700 text-lg md:text-xl leading-relaxed">"{t.quote}"</p>
                <div className="font-semibold text-blue-700 text-base md:text-lg">- {t.name}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Call to Action */}
      <div className="container mx-auto px-4 text-center mb-24">
        <h2 className="text-xl md:text-3xl font-bold mb-6 text-blue-800">Ready to Start Earning?</h2>
        <p className="mb-8 text-gray-700 text-base md:text-lg max-w-2xl mx-auto">Join hundreds of satisfied owners. Get your vending machine today and watch your passive income grow!</p>
        <Link to="/contact" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg text-lg w-full md:w-auto inline-block">Get Started</Link>
      </div>
    </>
  );
}

export default Home; 